"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick(['cite']);
//# sourceMappingURL=blockquote.js.map